import React, {useEffect, useState} from "react";
import "../../css/tools/PinTags.css";
import '../../css/tools/ImageImporter.css';
import '../../css/form/Form.css'
import FormBuilder from "../../class/tool/FormBuilder"


import logo from "../../image/logo/sigle-color.png";
import TrashIcon from "../icons/TrashIcon";
import EditIcon from "../icons/EditIcon";
import ClientIcon from "../icons/ClientIcon";
import StoreSettingController from "../../stories/_setting/StoreSettings/StoreSettingController";
import InputColor from "../form/input/InputColor";

const ImageImporter = props => {
    const { url, store_id, index, color, imageAdded, imageRemoved } = props;
    const [loading, setLoading] = useState(true);

    const [popo, setPopo] = useState(props.url);

    const removeLogo = () => {
        console.log('remove')

        let setting = JSON.parse(localStorage.getItem("storeSettings"))

        let controller = new StoreSettingController()
        controller._callback = handleRemoveLogo

        controller.put(setting, Object.create({"store_id": store_id, "logo": null}))

        imageRemoved !== undefined && imageRemoved(index)
    };

    const handleRemoveLogo = () => {
        setPopo(undefined)
    }

    const addImage = () => {
        console.log('addImage')

        //TODO:


        if (imageAdded !== undefined && url !== undefined)
            imageAdded()
        setPopo(logo)
    };

    const handleSelectColor = () => {
        // TOD0: upate store_settings set logo = null

        console.log('change color')
    };


    return (
        <div id={""} className={"imageImporter"}>

            <img className="image" src={ popo === undefined ? logo : popo } alt="bobby brown"/> :

            <div className={"importerActions"}>
                { popo === undefined ?
                    <svg title="popo" className="edit action" viewBox="0 0 512 512" onClick={ addImage } >
                        <path d="M257 0C116.39 0 0 114.39 0 255s116.39 257 257 257 255-116.39 255-257S397.61 0 257 0zm135 285H287v107c0 16.54-13.47 30-30 30-16.54 0-30-13.46-30-30V285H120c-16.54 0-30-13.46-30-30s13.46-30 30-30h107V120c0-16.54 13.46-30 30-30 16.53 0 30 13.46 30 30v105h105c16.53 0 30 13.46 30 30s-13.47 30-30 30z" />
                    </svg> :
                    <svg className="edit action" viewBox="0 0 492.493 492" onClick={ addImage  }>
                        <path d="M304.14 82.473L33.165 353.469a10.799 10.799 0 00-2.816 4.949L.313 478.973a10.716 10.716 0 002.816 10.136 10.675 10.675 0 007.527 3.114 10.6 10.6 0 002.582-.32l120.555-30.04a10.655 10.655 0 004.95-2.812l271-270.977zm0 0M476.875 45.523L446.711 15.36c-20.16-20.16-55.297-20.14-75.434 0l-36.949 36.95 105.598 105.597 36.949-36.949c10.07-10.066 15.617-23.465 15.617-37.715s-5.547-27.648-15.617-37.719zm0 0" />
                    </svg>
                }
                { popo !== undefined &&
                <svg className="trash action" viewBox="0 0 1024 1024"  onClick={ removeLogo }>
                    <path d="M724.9 952.2h-423c-22.1 0-40.4-17.1-41.9-39.2l-36.3-539.6c-1.6-24.3 17.6-44.8 41.9-44.8h495.6c24.3 0 43.5 20.6 41.9 44.8L766.8 913c-1.5 22.1-19.8 39.2-41.9 39.2zm119.6-702.3h-657c-.6 0-1-.4-1-1V134c0-.6.4-1 1-1h657c.6 0 1 .4 1 1v114.8c0 .6-.4 1.1-1 1.1z" />
                    <path d="M690.9 189.5H339.8c-.6 0-1-.4-1-1V57.9c0-.6.4-1 1-1h351.1c.6 0 1 .4 1 1v130.6c0 .5-.4 1-1 1z" />
                </svg>
                }
                <div className="client action" onClick={ () => {
                    let element = document.getElementById("input_color_logo");
                    element.classList.contains("hidden") ? element.classList.remove("hidden") : element.classList.add("hidden");
                } }>
                    <InputColor
                        key= "0"
                        id = "input_color_logo"
                        classname = "hidden"
                        value={ color }
                        handleChange={ handleSelectColor }
                    />
                </div>
                {/*
                return <InputColor
                attribute={ row.attribute }
                returnType={ row.returnType }
                classname={ row.classnameInput }
                small={ row.small }
                value={ values[row.attribute] !== undefined ? values[row.attribute] : "" }
                handleChange={ handleChange != null ? handleChange : () => {} } />
                */}
            </div>
        </div>
    );
}

export default ImageImporter;
